import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useEffect, useMemo } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { fullPageLoadingIndicator } from '@magento/venia-ui/lib/components/LoadingIndicator';
import { useSelector } from 'react-redux';
import ResourcesTop from './resourcesTop';
import { TopTabNavigation } from '../../components';
import { useResources } from './useResources';
import ResourcesContent from './resourcesContent';
import getCustomerGroupData from '../../hooks/getCustomerGroupData';
import { Meta, StoreTitle } from '@magento/venia-ui/lib/components/Head';

var Resources = function Resources() {
  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      activeTabData = _useState2[0],
      setActiveTabData = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      productResourcesData = _useState4[0],
      setProductResourcesData = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      searchResourcesResult = _useState6[0],
      setSearchResourcesResult = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      selectedSubcategories = _useState8[0],
      setSelectedSubcategories = _useState8[1];

  var _useState9 = useState(null),
      _useState10 = _slicedToArray(_useState9, 2),
      imagesAssets = _useState10[0],
      setImageAssets = _useState10[1];

  var location = useLocation();
  var history = useHistory();

  var _getCustomerGroupData = getCustomerGroupData(),
      customer_flow_map_group = _getCustomerGroupData.customer_flow_map_group,
      loading = _getCustomerGroupData.loading;

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      browserBackClicked = _useState12[0],
      setBrowserBackClicked = _useState12[1];

  window.addEventListener('popstate', function (event) {
    if (!browserBackClicked) setBrowserBackClicked(true);
  });
  useEffect(function () {
    return browserBackClicked && history.push(new URLSearchParams(location.search).get('from'));
  }, [browserBackClicked]);

  var _useResources = useResources(),
      loadingAll = _useResources.loadingAll,
      handleSearch = _useResources.handleSearch,
      productResources = _useResources.productResources,
      setSearchApi = _useResources.setSearchApi,
      handleSearchImage = _useResources.handleSearchImage,
      imagesData = _useResources.imagesData,
      setFormApi = _useResources.setFormApi,
      formApiRef = _useResources.formApiRef,
      isSearchEmpty = _useResources.isSearchEmpty,
      category = _useResources.category,
      pimcoreAssetHost = _useResources.pimcoreAssetHost;

  useEffect(function () {
    return handleSearch('');
  }, [activeTabData === null || activeTabData === void 0 ? void 0 : activeTabData.name]);
  useEffect(function () {
    return productResources && isSearchEmpty ? setProductResourcesData(productResources) : setProductResourcesData(null);
  }, [productResources]);
  var resourcesAll = useSelector(function (state) {
    return state.resources.resourcesLinks;
  });
  useEffect(function () {
    if (imagesData) {
      setImageAssets(imagesData);
    }
  }, [imagesData]);
  useEffect(function () {
    var _history$location, _history$location$sta;

    if (!location.search && resourcesAll) history.push("/resources?tab=".concat(resourcesAll[0].name, "&from=").concat((_history$location = history.location) === null || _history$location === void 0 ? void 0 : (_history$location$sta = _history$location.state) === null || _history$location$sta === void 0 ? void 0 : _history$location$sta.from));

    if (resourcesAll) {
      var queryParams = new URLSearchParams(location.search).get('tab');
      setActiveTabData(resourcesAll === null || resourcesAll === void 0 ? void 0 : resourcesAll.find(function (resource) {
        return queryParams === null || queryParams === void 0 ? void 0 : queryParams.includes(resource.name);
      }));
    }
  }, [location.search, resourcesAll === null || resourcesAll === void 0 ? void 0 : resourcesAll.length]);
  useEffect(function () {
    var _productResourcesData, _productResourcesData2;

    var filteredItems = [];
    var activeFormat;
    if ((activeTabData === null || activeTabData === void 0 ? void 0 : activeTabData.name) === 'CAD') activeFormat = 'cad';else if ((activeTabData === null || activeTabData === void 0 ? void 0 : activeTabData.name) === 'Revit') activeFormat = 'revit';else activeFormat = 'image';
    if (!(productResourcesData !== null && productResourcesData !== void 0 && (_productResourcesData = productResourcesData.items) !== null && _productResourcesData !== void 0 && _productResourcesData.length)) return setSearchResourcesResult(null);
    productResourcesData === null || productResourcesData === void 0 ? void 0 : (_productResourcesData2 = productResourcesData.items) === null || _productResourcesData2 === void 0 ? void 0 : _productResourcesData2.map(function (item) {
      var filesImage = (item === null || item === void 0 ? void 0 : item.hf_internal_images_block) && JSON.parse(item === null || item === void 0 ? void 0 : item.hf_internal_images_block);
      filesImage === null || filesImage === void 0 ? void 0 : filesImage.forEach(function (item) {
        if (item.ImageType === '2D CAD' || item.ImageType === '3D CAD') {
          if (activeFormat === 'cad') {
            var _item$ProductImageFil, _item$ProductImageFil2, _item$ProductImageFil3, _item$ProductImageFil4, _item$ProductImageFil5;

            filteredItems.push({
              // strip the path from the file name
              file_name: (item === null || item === void 0 ? void 0 : (_item$ProductImageFil = item.ProductImageFiles[0]) === null || _item$ProductImageFil === void 0 ? void 0 : (_item$ProductImageFil2 = _item$ProductImageFil.path) === null || _item$ProductImageFil2 === void 0 ? void 0 : _item$ProductImageFil2.split('/').pop()) || item.sku,
              file_format: 'DWG',
              //item?.ImageType || activeFormat,
              // url: `https://d1dzdvn5l1godq.cloudfront.net/assets${
              url: "".concat(pimcoreAssetHost).concat((item === null || item === void 0 ? void 0 : (_item$ProductImageFil3 = item.ProductImageFiles[0]) === null || _item$ProductImageFil3 === void 0 ? void 0 : _item$ProductImageFil3.path) || (item === null || item === void 0 ? void 0 : item.ProductImageFiles[0])),
              file_size: item === null || item === void 0 ? void 0 : (_item$ProductImageFil4 = item.ProductImageFiles[0]) === null || _item$ProductImageFil4 === void 0 ? void 0 : _item$ProductImageFil4.size,
              date: item === null || item === void 0 ? void 0 : (_item$ProductImageFil5 = item.ProductImageFiles[0]) === null || _item$ProductImageFil5 === void 0 ? void 0 : _item$ProductImageFil5.lastUpdated,
              customer_price_group: 'General',
              customer_group: 'HF Employee,Wholesale Dealers,RES Reps,RES Designer,Non-Stock Dealers,Trade Direct Account,COM Reps,COM Non-Purchasing,COM Purchasing,Customer Service Team, Not logged-in'
            });
          }
        } else {
          if (activeFormat === 'revit') {
            var _item$ProductImageFil6, _item$ProductImageFil7, _item$ProductImageFil8, _item$ProductImageFil9, _item$ProductImageFil10;

            filteredItems.push({
              file_name: item === null || item === void 0 ? void 0 : (_item$ProductImageFil6 = item.ProductImageFiles[0]) === null || _item$ProductImageFil6 === void 0 ? void 0 : (_item$ProductImageFil7 = _item$ProductImageFil6.path) === null || _item$ProductImageFil7 === void 0 ? void 0 : _item$ProductImageFil7.split('/').pop(),
              file_format: 'RFA',
              //item?.ImageType || activeFormat,
              // url: `https://d1dzdvn5l1godq.cloudfront.net/assets${
              url: "".concat(pimcoreAssetHost).concat((item === null || item === void 0 ? void 0 : (_item$ProductImageFil8 = item.ProductImageFiles[0]) === null || _item$ProductImageFil8 === void 0 ? void 0 : _item$ProductImageFil8.path) || (item === null || item === void 0 ? void 0 : item.ProductImageFiles[0])),
              file_size: item === null || item === void 0 ? void 0 : (_item$ProductImageFil9 = item.ProductImageFiles[0]) === null || _item$ProductImageFil9 === void 0 ? void 0 : _item$ProductImageFil9.size,
              date: item === null || item === void 0 ? void 0 : (_item$ProductImageFil10 = item.ProductImageFiles[0]) === null || _item$ProductImageFil10 === void 0 ? void 0 : _item$ProductImageFil10.lastUpdated,
              customer_price_group: 'General',
              customer_group: 'HF Employee,Wholesale Dealers,RES Reps,RES Designer,Non-Stock Dealers,Trade Direct Account,COM Reps,COM Non-Purchasing,COM Purchasing,Customer Service Team, Not logged-in'
            });
          }
        }
      });
      setSearchResourcesResult(filteredItems.length > 0 ? filteredItems : null);
    });
  }, [productResourcesData, pimcoreAssetHost]); //function that handles click on category filter and saves checked items  to store

  var handleCheckboxClick = function handleCheckboxClick(subcategory) {
    if (!selectedSubcategories.includes(subcategory)) {
      setSelectedSubcategories(function (prevState) {
        return [].concat(_toConsumableArray(prevState), [subcategory]);
      });
    } else {
      setSelectedSubcategories(function (prevState) {
        return prevState.filter(function (item) {
          return item.subcategory_id !== subcategory.subcategory_id;
        });
      });
    }
  };

  var links = resourcesAll === null || resourcesAll === void 0 ? void 0 : resourcesAll.filter(function (item) {
    if (item.customer_group) {
      var _item$customer_group;

      if (item.name === 'Forms and Docs' && !customer_flow_map_group) return null;else return (_item$customer_group = item.customer_group) === null || _item$customer_group === void 0 ? void 0 : _item$customer_group.includes(customer_flow_map_group ? customer_flow_map_group : 'Consumer');
    } else return item;
  }).map(function (category) {
    return {
      title: category.name,
      id: category.name
    };
  });
  useEffect(function () {
    var _links$, _links$2;

    return (links === null || links === void 0 ? void 0 : links.length) === 1 && new URLSearchParams(location.search).get('tab') !== (links === null || links === void 0 ? void 0 : (_links$ = links[0]) === null || _links$ === void 0 ? void 0 : _links$.id) && history.push("resources?tab=".concat(links === null || links === void 0 ? void 0 : (_links$2 = links[0]) === null || _links$2 === void 0 ? void 0 : _links$2.id));
  }, [links]); //function that changes the content by clicking on link (changing resources category)
  //also resets selected sub categories and search results

  var handleActiveTab = function handleActiveTab(categoryId) {
    var _formApiRef$current;

    setActiveTabData(resourcesAll.find(function (item) {
      return item.name === categoryId;
    }));
    setSelectedSubcategories([]);
    setSearchResourcesResult(null);
    setImageAssets(null);
    formApiRef === null || formApiRef === void 0 ? void 0 : (_formApiRef$current = formApiRef.current) === null || _formApiRef$current === void 0 ? void 0 : _formApiRef$current.reset();
    history.push("resources?tab=".concat(categoryId));
  }; //handles search submit -> front has all needed data so no query needed to be executed


  var handleSearchSubmit = function handleSearchSubmit(data) {
    var _data$search;

    return ((_data$search = data.search) === null || _data$search === void 0 ? void 0 : _data$search.length) > 5 && handleSearch(data.search);
  };

  var resetSelectedSubcategories = function resetSelectedSubcategories() {
    return setSelectedSubcategories([]);
  };

  if (loadingAll || loading) return fullPageLoadingIndicator;
  return React.createElement(React.Fragment, null, React.createElement(StoreTitle, null, category === null || category === void 0 ? void 0 : category.name), React.createElement(Meta, {
    name: 'title',
    content: category !== null && category !== void 0 && category.meta_title ? category === null || category === void 0 ? void 0 : category.meta_title : category === null || category === void 0 ? void 0 : category.name
  }), React.createElement(Meta, {
    name: 'description',
    content: category !== null && category !== void 0 && category.meta_description ? category === null || category === void 0 ? void 0 : category.meta_description : ''
  }), React.createElement(Meta, {
    name: 'keywords',
    content: category !== null && category !== void 0 && category.meta_keywords ? category === null || category === void 0 ? void 0 : category.meta_keywords : ''
  }), React.createElement(ResourcesTop, null), React.createElement(TopTabNavigation, {
    navLinks: links,
    activeTab: activeTabData === null || activeTabData === void 0 ? void 0 : activeTabData.name,
    handleActiveTab: handleActiveTab,
    classes: {
      linkListItem: 'text-black',
      root: 'bg-snowbound'
    },
    isResourcePage: true
  }), React.createElement(ResourcesContent, {
    activeTabData: activeTabData,
    handleCheckboxClick: handleCheckboxClick,
    resetSelectedSubcategories: resetSelectedSubcategories,
    selectedSubcategories: selectedSubcategories,
    searchResourcesResult: searchResourcesResult,
    handleSearchSubmit: handleSearchSubmit,
    setSearchApi: setSearchApi,
    handleSearchImage: handleSearchImage,
    imagesData: imagesAssets,
    setFormApi: setFormApi,
    productResourcesData: productResourcesData
  }));
};

export default Resources;